module.exports = __webpack_public_path__ + "img/firefox.da68df42.svg";